function CWALegalCtrl() {
}


module.exports = CWALegalCtrl;
